import { CustomLinkStatus, CustomLinkSubStatus } from '../../../../models/payment-links-custom';
import { Label, StatusContainer } from './styles';

export type SizeAllowed = 'md' | 'sm';

interface StatusProps {
	subStatus: CustomLinkSubStatus;
	size?: SizeAllowed;
	borderFull?: boolean;
}

interface StatusTransform {
	label: string;
	status: CustomLinkStatus;
}

const CustomLinkComponentStatus = ({ subStatus, size, borderFull = false }: StatusProps) => {
	const colorStatus = new Map<CustomLinkSubStatus, StatusTransform>([
		[
			'active',
			{
				label: 'Activo',
				status: 'active',
			},
		],
		[
			'completed',
			{
				label: 'Completado',
				status: 'active',
			},
		],
		[
			'expired',
			{
				label: 'Expirado',
				status: 'active',
			},
		],
		[
			'finalized',
			{
				label: 'Finalizado',
				status: 'inactive',
			},
		],
		[
			'paused',
			{
				label: 'Pausado',
				status: 'inactive',
			},
		],
		[
			'pending',
			{
				label: 'Pendiente',
				status: 'inactive',
			},
		],
	]);

	return (
		<StatusContainer
			subStatus={subStatus ? subStatus : 'pending'}
			size={size}
			borderFull={borderFull}
		>
			<Label subStatus={subStatus ? subStatus : 'pending'} size={size}>
				{colorStatus.get(subStatus ? subStatus : 'pending')?.label}
			</Label>
		</StatusContainer>
	);
};

export { CustomLinkComponentStatus };
